import { datadogLogs } from '@datadog/browser-logs'

if (process.env.NODE_ENV === 'production') { // This includes our staging env
  datadogLogs.init({
    clientToken: process.env.VUE_APP_DATADOG_TOKEN,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    service: 'HS Pro Report App',
    version: process.env.VUE_APP_HS_REPORT_VERSION,
    applicationId: process.env.VUE_APP_HS_REPORT_VERSION,
  })
}
